import React from 'react';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {LocationViewQuery, LocationViewQueryVariables} from 'samples/locations/__generated/LocationViewQuery';
import LocationView from 'samples/locations/LocationView';
import {
  LOCATION_VIEW_QUERY,
  LocationInfo,
  translateToLocationInfo,
} from 'samples/locations/LocationViewConstants';
import * as StorableAuth from 'samples/storables/StorableAuth';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

export default function LocationViewContainer(props: {locationId: string}): JSX.Element | null {
  const result = useBenchlingQuery<LocationViewQuery, LocationViewQueryVariables>(LOCATION_VIEW_QUERY, {
    variables: {id: props.locationId},
    renderCachedDataWhenRefetching: true,
    fetchPolicy: 'cache-and-network',
  });

  if (result.type === QueryResultType.PENDING) {
    return <CenteredHorizontalThrobber />;
  } else if (result.type === QueryResultType.SUCCESS) {
    const location = result.data.location;
    if (isInaccessible(location)) {
      return (
        <StorableAuth.ErrorBanner message="Item not found or you may not have permissions to view the item." />
      );
    }

    const locationInfo: LocationInfo = translateToLocationInfo(location);

    const reload = (): void => {
      result.refetch({id: props.locationId});
    };

    return <LocationView location={locationInfo} reload={reload} />;
  } else {
    return null;
  }
}
